import React,{useEffect,useState} from "react";
import {Route,Link, Navigate} from "react-router-dom";


const SuperAdminRoute =({element}) => {

   


    const user = localStorage.getItem("TREXO_AUTH_TOKEN");

    let check=false

   if (user){
    check = true;
   }


    return check ? element
    : (
       <Navigate to = {"/superAdmin/login"} />
    )
}

export default SuperAdminRoute;